module.exports = function () {
 if ( document.querySelector(".header") ) {
     // elements
     const header = document.querySelector(".header");
     const btnHamburger = header.querySelector(".header__ham");
     const menuItemsHasChildren = [...header.querySelectorAll(".menu-item-has-children > a")];
     
     // vars
     let isOpen = false;
     
     // init
     header.classList.add("init");
     
     // toggle sub menu
     if ( menuItemsHasChildren ) {
        menuItemsHasChildren.forEach(item => {
            item.addEventListener("click", (e) => {
                e.preventDefault();
                const menuItem = e.currentTarget?.parentNode;
                const subMenu = menuItem.querySelector(".sub-menu");

                if ( menuItem.classList.contains("open") ) {
                    // close current
                    menuItem.classList.remove("open");
                    subMenu.style.maxHeight = null;
                }
                else {
                    // close all
                    header.querySelectorAll(".menu-item-has-children.open .sub-menu")
                        .forEach(el => {
                            el.style.maxHeight = null;
                            el.parentNode.classList.remove("open");
                        });

                    // open current
                    menuItem.classList.add("open");
                    subMenu.style.maxHeight = `${subMenu.scrollHeight}px`;
                }
            })
        })
     }
         
     const closeWithResize = () => {
         if ( isOpen && window.innerWidth >= 1280 ) close();
     }
     
     const closeOutSide = (e) => {
       if ( !header.contains(e.target) ) close();
     }
     
     const open = () => {
         header.classList.add("loaded");
         header.classList.add("open");
         document.body.classList.add("overflow-hidden");
         
         window.addEventListener("resize", closeWithResize);
         window.addEventListener("click", closeOutSide);
         isOpen = true;
     }
     
     const close = () => {
         header.classList.remove("open");
         document.body.classList.remove("overflow-hidden");
         
         window.removeEventListener("resize", closeWithResize);
         window.removeEventListener("click", closeOutSide);
         isOpen = false;
     }
     
     if ( btnHamburger ) {
         btnHamburger.addEventListener("click", () => isOpen ?  close() :  open());
     }
 }   
}